interface Props {
  type: 'start' | 'today';
  date: string; // ISO
  detail?: string; // optional zusätzliche Info, z.B. "noch keine neue Session geplant"
}

const FORMATTER = new Intl.DateTimeFormat('de-DE', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});

export function TimelineAnchor({ type, date, detail }: Props) {
  const dotColor =
    type === 'today'
      ? 'bg-emerald-500 border-emerald-500'
      : 'bg-muted-foreground border-muted-foreground';
  const label =
    type === 'today'
      ? `Heute · ${FORMATTER.format(new Date(date))}`
      : `Klient angelegt · ${FORMATTER.format(new Date(date))}`;
  return (
    <div className="relative pl-6">
      <span
        className={`absolute left-[1px] top-1.5 inline-block h-3 w-3 rounded-full border-2 ${dotColor}`}
      />
      <div className="text-xs italic text-muted-foreground">
        {label}
        {detail && <span className="ml-1">· {detail}</span>}
      </div>
    </div>
  );
}
